<template>
	<div class="flex flex-col">
		<div class="flex flex-col gap-strong-friends">
			<h2 class="typography-h3-str">
				{{ section.title }}
			</h2>
			<h4 class="typography-s1-reg">
				{{ section.subtitle }}
			</h4>
		</div>
		<div class="gap-2 mt-casual-friends flex flex-col text-justify">
			<div
				v-for="line in formattedContent"
				:key="line"
				class="flex items-start"
			>
				<span class="w-6 shrink-0 text-right">{{ getNumber(line) }}&nbsp;</span>
				<span class="flex-1 break-words">{{ getText(line) }}</span>
			</div>
		</div>
		<div v-if="originalContentLength > 10">
			<div
				v-if="isShowMore"
				@click="handleClick"
				class="typography-s1-reg mt-16px cursor-pointer text-start text-o-500 underline"
			>
				{{ pageContent.detail_button_view_less }}
			</div>
			<div
				v-else
				@click="handleClick"
				class="typography-s1-reg mt-16px cursor-pointer text-start text-o-500 underline"
			>
				{{ pageContent.detail_button_view_more }}
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { ref, computed, type PropType } from 'vue'
import {
	createGAEvent,
	GaGeneralEvent,
	GaGeneralPageName,
} from '@/assets/ts/customEvent'

export interface ITermsAndConditions {
	title: string
	subtitle: string
	type: string
	content?: string
}

const emit = defineEmits(['click'])
const isShowMore = ref(false)

const props = defineProps({
	section: {
		type: Object as PropType<ITermsAndConditions>,
		default: () => ({
			menuTitle: 'string',
			title: 'Image section title',
			subtitle: 'Limited quantity, only the fastest finger get to save big!',
			type: 'text',
			content:
				'1. Promotion period starts from 2 February 2025 - 14 February 2025.\n2. Limited quota for the offer. \n3.The price shown on the packages are discounted price already.\n4. Promotion period starts from 2 February 2025 - 14 February 2025.\n5. Promotion period starts from 2 February 2025 - 14 February 2025.\n6. Promotion period starts from 2 February 2025 - 14 February 2025.\n7. Promotion period starts from 2 February 2025 - 14 February 2025.\n8. Promotion period starts from 2 February 2025 - 14 February 2025 Promotion period starts from 2 February 2025 - 14 February 2025Promotion period starts from 2 February 2025 - 14 February 2025Promotion period starts from 2 February 2025 - 14 February 2025.\n9. Promotion period starts from 2 February 2025 - 14 February 2025.\n10. Promotion period starts from 2 February 2025 - 14 February 2025.\n11. Promotion period starts from 2 February 2025 - 14 February 2025.',
		}),
	},
	pageContent: {
		type: Object as PropType<{ [key: string]: string }>,
		required: true,
	},
})

const handleClick = () => {
	isShowMore.value = !isShowMore.value
	if (isShowMore.value) {
		createGAEvent(GaGeneralEvent.ButtonClick, {
			page_name: GaGeneralPageName.MercariCampaign,
			button_name: 'View More T&C',
		})
	}
	emit('click')
}

const originalContentLength = computed(() => {
	if (!props.section.content) return 0
	return props.section.content.trim().split('\n').length
})

const formattedContent = computed(() => {
	if (!props.section.content) return []
	const result = props.section.content
		.trim()
		.split('\n')
		.map(item => item.trim())

	return isShowMore.value ? result : result.slice(0, 10)
})

const getNumber = (line: string) => {
	const match = line.match(/^(\d+)\./)
	return match ? `${match[1]}.` : ''
}

const getText = (line: string) => {
	return line.replace(/^\d+\.\s*/, '')
}
</script>
